import React from "react";


export default function About() {
  return (
  <><div>
        <div className="containerP">
           <div className="piramid">
              <div className="side side1"></div>
              <div className="side side2"></div>
              <div className="side side3"></div>
              <div className="side side4"></div>
              <div className="bottom_shadow"></div>
           </div>
         </div>
         <br></br>
        <h1 id="name">Jay Tranberg</h1>
        
      </div>
       </>
    
  
  );
}

